"use client";

import svgPaths from "./components/header/dathacons/svg-bvmy9onrap";

/** Icon glyph map — khớp FullWidth Expertise (Fi4, Fi3, Fi5, Layer1–3) */
export type ExpertiseIconKey =
  | "sustainability"
  | "safety"
  | "craftsmanship"
  | "design"
  | "mep"
  | "concrete";

export function ExpertiseIconGlyph({ name }: { name: ExpertiseIconKey }) {
  switch (name) {
    case "sustainability":
      return <IconSustainability />;
    case "safety":
      return <IconSafety />;
    case "craftsmanship":
      return <IconCraftsmanship />;
    case "design":
      return <IconDesign />;
    case "mep":
      return <IconMep />;
    case "concrete":
      return <IconConcrete />;
    default:
      return <IconSustainability />;
  }
}

function IconSustainability() {
  return (
    <div className="relative shrink-0 size-[64px]" data-name="fi_12785662">
      <svg
        className="absolute block size-full"
        fill="none"
        preserveAspectRatio="none"
        viewBox="0 0 64 64"
      >
        <g>
          <path d={svgPaths.p13894700} fill="var(--fill-0, #FFA411)" />
          <path d={svgPaths.p307d600} fill="var(--fill-0, #FFA411)" />
          <path d={svgPaths.p3419ac00} fill="var(--fill-0, #FFA411)" />
          <path d={svgPaths.p15175900} fill="var(--fill-0, #FFA411)" />
          <path d={svgPaths.p36bd7b80} fill="var(--fill-0, #FFA411)" />
          <path d={svgPaths.pd618400} fill="var(--fill-0, #FFA411)" />
          <path d={svgPaths.p289c3600} fill="var(--fill-0, #FFA411)" />
          <path d={svgPaths.p3e834380} fill="var(--fill-0, #FFA411)" />
          <path d={svgPaths.p2e2178c0} fill="var(--fill-0, #FFA411)" />
          <path d={svgPaths.p20e17980} fill="var(--fill-0, #FFA411)" />
          <path d={svgPaths.p299e6d00} fill="var(--fill-0, #FFA411)" />
          <path d={svgPaths.p28c05980} fill="var(--fill-0, #FFA411)" />
          <path d={svgPaths.p2ec4eb00} fill="var(--fill-0, #FFA411)" />
          <path d={svgPaths.p298bb300} fill="var(--fill-0, #FFA411)" />
          <path d={svgPaths.p3641d480} fill="var(--fill-0, #FFA411)" />
        </g>
      </svg>
    </div>
  );
}

function IconSafety() {
  return (
    <div className="relative shrink-0 size-[64px]" data-name="fi_12785640">
      <svg
        className="absolute block size-full"
        fill="none"
        preserveAspectRatio="none"
        viewBox="0 0 64 64"
      >
        <g>
          <path d={svgPaths.p25a5c680} fill="var(--fill-0, #FFA411)" />
          <path d={svgPaths.pe34e200} fill="var(--fill-0, #FFA411)" />
          <path d={svgPaths.p20a79780} fill="var(--fill-0, #FFA411)" />
          <path d={svgPaths.p1df73100} fill="var(--fill-0, #FFA411)" />
          <path d={svgPaths.p184aed80} fill="var(--fill-0, #FFA411)" />
        </g>
      </svg>
    </div>
  );
}

function IconCraftsmanship() {
  return (
    <div className="relative shrink-0 size-[64px]" data-name="fi_12785836">
      <svg
        className="absolute block size-full"
        fill="none"
        preserveAspectRatio="none"
        viewBox="0 0 64 64"
      >
        <g>
          <path d={svgPaths.p39870a00} fill="var(--fill-0, #FFA411)" />
          <path d={svgPaths.p102d7b00} fill="var(--fill-0, #FFA411)" />
          <path d={svgPaths.p350c8e00} fill="var(--fill-0, #FFA411)" />
        </g>
      </svg>
    </div>
  );
}

/** Cùng glyph Layer1/Group8 — cấu trúc phẳng như Fi4/Fi3 để không bị clip trong table/overflow contexts. */
function IconDesign() {
  return (
    <div className="relative shrink-0 size-[64px]" data-name="Layer_1">
      <svg
        className="absolute inset-0 block size-full"
        fill="none"
        preserveAspectRatio="xMidYMid meet"
        viewBox="0 0 63.7488 63.7471"
      >
        <g>
          <path d={svgPaths.p26c50b00} fill="#FFA411" />
          <path d={svgPaths.p6522380} fill="#FFA411" />
          <path d={svgPaths.pab72800} fill="#FFA411" />
        </g>
      </svg>
    </div>
  );
}

function IconMep() {
  return (
    <div className="relative shrink-0 size-[64px]" data-name="Layer_1">
      <svg
        className="absolute inset-0 block size-full"
        fill="none"
        preserveAspectRatio="xMidYMid meet"
        viewBox="0 0 63.75 52.875"
      >
        <g>
          <path d={svgPaths.p3aaac380} fill="#FFA411" />
          <path d={svgPaths.pe9a6600} fill="#FFA411" />
          <path d={svgPaths.p30ec7980} fill="#FFA411" />
          <path d={svgPaths.p75c3b70} fill="#FFA411" />
        </g>
      </svg>
    </div>
  );
}

function IconConcrete() {
  return (
    <div className="relative shrink-0 size-[64px]" data-name="Layer_1">
      <svg
        className="absolute inset-0 block size-full"
        fill="none"
        preserveAspectRatio="xMidYMid meet"
        viewBox="0 0 63.75 63.75"
      >
        <g>
          <path d={svgPaths.p2f2eb070} fill="#FFA411" />
          <path d={svgPaths.p3ce9ff00} fill="#FFA411" />
        </g>
      </svg>
    </div>
  );
}
